import {
  createSlice,
  isPending,
  isRejected,
  SliceSelectors,
} from "@reduxjs/toolkit";

import {
  getContactInformationThunk,
  getContactMethodsThunk,
  getOptInSettingsThunk,
  saveOptInFormThunk,
  validateOptInKeyThunk,
} from "./thunks";
import { IOptInState, OptInReducers } from "./types";

const initialState = {
  pendingRequests: 0,
  isInitialized: false,
  error: "",
  contactData: {},
  settings: {},
  optInKey: {},
  contactMethods: [],
  successMessage: "",
};

export const optInSlice = createSlice<
  IOptInState,
  OptInReducers,
  "optInSlice",
  SliceSelectors<IOptInState>
>({
  name: "optInSlice",
  initialState,
  reducers: {
    setInitialized: state => {
      state.isInitialized = true;
    },
  },
  extraReducers: builder => {
    builder.addCase(validateOptInKeyThunk.fulfilled, (state, { payload }) => {
      state.optInKey = payload;
      state.pendingRequests -= 1;
    });
    builder.addCase(
      getContactInformationThunk.fulfilled,
      (state, { payload }) => {
        state.contactData = payload;
        state.pendingRequests -= 1;
      }
    );
    builder.addCase(getOptInSettingsThunk.fulfilled, (state, { payload }) => {
      state.settings = payload;
      state.pendingRequests -= 1;
    });
    builder.addCase(getContactMethodsThunk.fulfilled, (state, { payload }) => {
      state.contactMethods = payload;
      state.pendingRequests -= 1;
    });
    builder.addCase(saveOptInFormThunk.fulfilled, (state, { payload }) => {
      state.successMessage = payload;
      state.pendingRequests -= 1;
    });
    builder.addMatcher(
      isPending(
        validateOptInKeyThunk,
        getContactInformationThunk,
        getOptInSettingsThunk,
        getContactMethodsThunk,
        saveOptInFormThunk
      ),
      state => {
        state.pendingRequests += 1;
        state.error = "";
      }
    );
    builder.addMatcher(
      isRejected(
        validateOptInKeyThunk,
        getContactInformationThunk,
        getOptInSettingsThunk,
        getContactMethodsThunk,
        saveOptInFormThunk
      ),
      (state, action) => {
        state.pendingRequests -= 1;
        state.error = action.payload?.message;
      }
    );
  },
});
export const { setInitialized } = optInSlice.actions;
export default optInSlice.reducer;
